const Config = {
  BACKEND_ENDPOINT: 'https://superbook-backend-dot-pv-backend-415303.uc.r.appspot.com/v1/',
  // BACKEND_ENDPOINT: 'http://localhost:3002/v1/',
  APP_ID: 'superbook',
}

export default Config
